import React from "react";
import "../index.css";
import { FaDiscord } from "react-icons/fa";
import SelectLanguage from "./SelectLanguage";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="relative bg-void border-t border-white/10 text-white overflow-hidden">
      {/* Gradient accent line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-reored to-transparent" />

      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-12 sm:py-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 items-start">
            {/* Brand */}
            <div className="text-center md:text-left">
              <h2 className="font-Bebas text-4xl tracking-widest mb-3">
                REO <span className="text-white/30 text-2xl">レオ</span>
              </h2>
              <p className="font-poppins text-white/45 text-sm leading-relaxed max-w-xs mx-auto md:mx-0 mb-5">
                The Discord bot that turns your server into a living world —
                battle pass, ranking, economy and roleplay.
              </p>
              <a
                href="https://discord.gg/v2TzrDz5Kz"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 font-poppins text-sm text-white/70 hover:text-white glass px-4 py-2 glass-hover"
              >
                <FaDiscord className="text-lg" /> Join the community
              </a>
            </div>

            {/* Quick links */}
            <div className="text-center md:text-left">
              <h3 className="font-Bebas text-xl tracking-widest text-white/80 mb-4">Explore</h3>
              <ul className="space-y-2 font-poppins text-sm">
                <li><Link to="/profile" className="text-white/45 hover:text-reored transition-colors">Customize Profile</Link></li>
                <li><Link to="/battlepass" className="text-white/45 hover:text-reored transition-colors">Battle Pass</Link></li>
                <li><Link to="/Marketplace" className="text-white/45 hover:text-reored transition-colors">Marketplace</Link></li>
              </ul>
            </div>

            {/* Language */}
            <div className="text-center md:text-left">
              <h3 className="font-Bebas text-xl tracking-widest text-white/80 mb-4">
                Language
              </h3>
              <SelectLanguage />
            </div>
          </div>

          {/* Bottom Section */}
          <div className="mt-10 sm:mt-14 pt-6 sm:pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs sm:text-sm text-white/30 font-poppins">
              © 2026 Reo Discord Bot · Subarashi Studios. All rights reserved.
            </p>
            <p className="text-xs text-white/20 font-poppins">
              Crafted with ❤ for the community
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
